export class ArrayUtils {
  static rangeFromOneTo(end: number): number[] {
    return Array(end)
      .fill(0)
      .map((_, index) => index + 1);
  }

  static filterUniq<T>(item: T, index: number, all: T[]): boolean {
    return all.indexOf(item) === index;
  }

  static reduceSum(sum: number, n: number): number {
    // The sum is undefined on the initial iteration.
    return sum === undefined ? n : sum + n;
  }

  static sum(array: number[]) {
    return array.reduce((accumulator, value) => accumulator + value, 0);
  }
}
